module.exports = "../images/icons-race-details/Price.svg";